"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataForQuery = void 0;
/** Arranges Data for use in a manualReads Query, return empty string if supply point is invalid */
var getDataForQuery = function (accountId, supplyPoints, fuel, mpxn) {
    var _a;
    var supply = supplyPoints.find(function (supply) {
        var _a;
        return supply.fuel === fuel &&
            ((_a = supply.supplyPointInfo) === null || _a === void 0 ? void 0 : _a.msn) &&
            (!mpxn || supply.mpxn === mpxn);
    });
    return {
        accountId: accountId,
        msn: ((_a = supply === null || supply === void 0 ? void 0 : supply.supplyPointInfo) === null || _a === void 0 ? void 0 : _a.msn) || '',
        mpxn: (supply === null || supply === void 0 ? void 0 : supply.mpxn) || '',
        //@ts-ignore Lowercase is not defined but it's part of TypeScript so acceptable here
        fuel: fuel.toLowerCase(),
        from: new Date((supply === null || supply === void 0 ? void 0 : supply.start) || 0),
    };
};
exports.getDataForQuery = getDataForQuery;
